import dayjs from "dayjs";
import { FormattedDate, FormattedTime } from "react-intl";

interface IProps {
  value?: string;
  showTime?: boolean;
  showSecond?: boolean;
}

const Date = ({ value, showTime, showSecond }: IProps) => {
  if (!value) return null;

  return (
    <>
      <FormattedDate value={dayjs(value).toDate()} />
      {showTime && (
        <>
          &nbsp;
          <FormattedTime value={value} />
        </>
      )}
      {!showTime && showSecond && dayjs(value).format(" hh:mm:ss A")}
    </>
  );
};

export { Date };
